(function () {
  'use strict';

  angular
    .module('itecAdministracio.productes.main.submain.entitats')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('productes.main.submain.entitats', {
        url: '/entitats',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosProductesHeaderSubmenuLinksValue){
                return permisosProductesHeaderSubmenuLinksValue;
              }
            }
          },
          'content@productes.main.submain': {
            templateUrl: 'productes/main/entitats/dades.tpl.html',
            controller: 'ProductesMainEntitatsCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_DADES_GENERALS'
      });
  }
}());
